import React, { Component } from 'react';
import language from '../../../../assets/languages/language';
import FrmSubscriptionCheck from '../../../RestAPI/FrmSubscription';
import PartnerFRMSubscriptionCheck from '../../../RestAPI/PartnerSubscription/FrmSubscription';
import FD from '../../../RestAPI/fetchData';
import App_data from '../../../config/App_data';
import AlertMessage from '../../../config/alertMessage';
import UserAnsweredNotAnsweredStatus from '../../../../components/UserAnsweredNotAnsweredStatus';
import { renderHTMLContent } from '../../../../common/function';
/* eslint-disable*/
class ViewFrmQues extends Component {
  constructor(props) {
    window.scrollTo(0, 0);
    super(props);
    this.state = {
      alert_status: false,
      MessageTitle: `${language.LC().ALERT}`,
      MessageContent: `${language.LC().ERROR}`,
      SubsciptionMessage: AlertMessage.messageContent_frm,
      questions: [],
      token: '',
      idname: '',
      readingName: this.props.params.reading,
      ValidToken: false,
      chapter_id: '',
      offset: 0,
      limit: 1000,
      answered: [],
      chapters: [],
      answered_state: [],
      subscriptionstatus: this.props.params.subscriptionstatus,
      level: this.props.params.level,
      selectedmenu: 'frm',
      videoPartLevel: this.props.params.level,
    };
    //  this.getAnswered = this.getAnswered.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  async componentDidMount() {
    window.scrollTo(0, 0);
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState({
        idname: storage_session['idname'],
        token: storage_session['token'],
      });
    }
    // var data = { token: this.state.token, idname: this.state.idname };
    var data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
      chapter_id: this.props.params.reading.chapter_no,
    };
    const getProfileInfo = {
      idname: storage_session['idname'],
      token: storage_session['token'],
    };
    await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', getProfileInfo).then(
      async resp => {
        if (resp.profileInfo) {
          this.setState({
            isVideo: resp.profileInfo.isVideo,
          });
        }
      },
    );
    await FD.callAPI(App_data.backend_api + '/frm_question_bank/getfrmVideos', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true, chapters: resp.frmvideo });
      } else {
        this.setState({ ValidToken: false });
      }
      // return resp;
    });

    var data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
    };
    await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
      var exam_selected = resp.profileInfo.exam_selected
        ? JSON.parse(resp.profileInfo.exam_selected)
        : resp.profileInfo.exam_selected;
      var subscription_details = resp.profileInfo.subscription_details
        ? JSON.parse(resp.profileInfo.subscription_details)
        : resp.profileInfo.subscription_details;
      this.setState({ subscription_details: subscription_details });

      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.setState({ showFreePremium: true });
        } else {
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            idname: storage_session['idname'],
            token: storage_session['token'],
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              // console.log(resp_exam);
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                const examPlanData = resp_exam.examPlan[0];
                isInArray_var = await PartnerFRMSubscriptionCheck.checkFrmVideosSubscription(
                  this.state.videoPartLevel,
                  exam_data,
                  examPlanData,
                );
                if (isInArray_var) {
                  this.setState({ showFreePremium: false });
                } else {
                  this.setState({ showFreePremium: true });
                }
              } else {
                console.log('fail');
              }
            },
          );
        }
      } else {
        if (resp.profileInfo.exam_selected == '') {
          this.setState({ showFreePremium: true });
        } else {
          var data_arr = JSON.parse(resp.profileInfo.exam_selected);
          var dataset = {
            idname: storage_session['idname'],
            token: storage_session['token'],
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = FrmSubscriptionCheck.checkFrmVideosSubscription(
                  this.state.videoPartLevel,
                  exam_data,
                );
                if (isInArray_var) {
                  this.setState({ showFreePremium: false });
                } else {
                  this.setState({ showFreePremium: true });
                }
              } else {
                console.log('fail');
              }
            },
          );
        }
      }
    });

    var data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
      reading_id: this.props.params.id,
      chapter_id: this.props.params.chapter_no,
      offset: this.state.offset,
      limit: this.state.limit,
      subscriptionstatus: this.state.subscriptionstatus,
    };

    FD.callAPI(App_data.backend_api + '/frm_question_bank/getQuestions', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true, questions: resp.questions });
        //this.setState({answered: resp.answered});
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  }
  _getReadings = () => {
    this.context.router.push({
      pathname: `/frm/readings/${this.props.params.chapter_no}`,
    });
  };

  _goToVideo = () => {
    this.context.router.push({
      pathname: `/frm/videodisplay/${this.props.params.chapter_no}/${this.state.showFreePremium ? 0 : 1
        }`,
      search: `?chapter_name=${this.props.params.reading}`,
    });
    // }
    // );
  };

  _getSubscribe = () => {
    this.context.router.push({
      pathname: '/subscribe/',
      state: { token: this.state.token, idname: this.state.idname },
    });
  };

  _beginChapter = async (item, e) => {
    if (item.chapter_id <= 4) {
      await this.setState({
        level: 1,
      });
    } else if (item.chapter_id > 4) {
      await this.setState({
        level: 2,
      });
    }

    // Find the offset (index) of the clicked question
    const { questions } = this.state;
    let offset = 0;
    if (questions && questions.length > 0) {
      offset = questions.findIndex(q => String(q.id) === String(item.id));
      if (offset < 0) offset = 0;
    }

    this.context.router.push({
      pathname:
        '/frm/chapter/' +
        item.chapter_id +
        '/' +
        item.reading_id +
        '/' +
        item.id +
        '/' +
        this.state.level +
        '/' +
        offset, // <-- add offset to the URL
      state: {
        token: this.state.token,
        idname: this.state.idname,
        reading: item.reading_id,
        chapter: item.chapter_id,
        offset: offset,
      },
    });
  };

  render() {
    const { chapters } = this.state;
    const filterVideoByChapter = chapters.filter(
      item => item.chapter_no === parseInt(this.props.params.chapter),
    )[0];
    let videosCount =
      filterVideoByChapter && filterVideoByChapter.Countvideos
        ? filterVideoByChapter.Countvideos
        : 0;
    let questions = this.state.questions;
    let data = '';

    // alert(this.state.answered);
    if (this.state.questions.length) {
      //alert(this.state.answered[3]);
      data = questions.map((item, index) => (
        // alert(this.state.answered[item.id])
        <div className='col-md-6 col-lg-4' key={index}>
          <div onClick={this._beginChapter.bind(this, item)} className='border_box'>
            <div className='border_box_title d-flex'>
              <img
                src={App_data.frontend_url + '/img/question_bank/question_icon-blu.svg'}
                className='margin_bottom_20'
                width='30'
                alt=''
              />
              <p className='ml-1'>
                {/* {language.LC().Q} {item.id}  */}
                {item.name} ({language.LC().Q} {item.id})
              </p>
            </div>
            <div className='padding_box'>
              {item.question ? (
                <div contentEditable='false' className='view_question_height view_questionhtml margin_bottom_40 frm_question_height'>
                  {renderHTMLContent(
                    item.question.substring(
                      0,
                      item.question.indexOf('$$') !== -1 ? item.question.indexOf('$$') : 450
                    ) + '...'
                  )}
                </div>
              ) : null}
              <UserAnsweredNotAnsweredStatus
                itemid={item.id}
                chapter_id={this.props.params.chapter_no}
                reading_id={this.props.params.id}
                idname={this.state.idname}
                token={this.state.token}
                answered_state={index}
                examRoute='frm_question_bank'
              />
            </div>
          </div>
        </div>
      ));
    } else {
      data = (
        <div className='loader_box'>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      );
    }
    return (
      <div className='animated fadeIn'>
        {this.props.params.chapter_no <= 4 ? (
          <div className='row'>
            <div className='col-md-8 margin_bottom_20'>
              <h1 className='section_head'>{this.state.readingName}</h1>
            </div>

            <div
              className={
                this.state.isVideo === true && videosCount > 0
                  ? `col-md-2 text-md-right margin_bottom_20`
                  : `col-md-4 text-md-right margin_bottom_20`
              }
            >
              <button
                type='button'
                className='btn btn-primary pointer_class'
                onClick={this._getReadings}
              >
                {' '}
                {language.LC().CHANGE_READING}{' '}
              </button>
            </div>
            {this.state.isVideo === true && videosCount > 0 ? (
              <div className='col-md-2 text-md-right margin_bottom_20'>
                <button
                  type='button'
                  className='btn btn-primary pointer_class'
                  onClick={this._goToVideo}
                >
                  {' '}
                  {language.LC().GO_TO_VIDEOS}
                </button>
              </div>
            ) : null}
          </div>
        ) : (
          <div className='row'>
            <div className='col-md-8 margin_bottom_20'>
              <h1 className='section_head'>{this.state.readingName}</h1>
            </div>

            <div
              className={
                this.state.isVideo === true && videosCount > 0
                  ? `col-md-2 text-md-right margin_bottom_20`
                  : `col-md-4 text-md-right margin_bottom_20`
              }
            >
              <button
                type='button'
                className='btn btn-primary pointer_class'
                onClick={this._getReadings}
              >
                {' '}
                {language.LC().CHANGE_READING}{' '}
              </button>
            </div>
            {this.state.isVideo === true && videosCount > 0 ? (
              <div className='col-md-2 text-md-right margin_bottom_20'>
                <button
                  type='button'
                  className='btn btn-primary pointer_class'
                  onClick={this._goToVideo}
                >
                  {' '}
                  {language.LC().GO_TO_VIDEOS}
                </button>
              </div>
            ) : null}
          </div>
        )}
        <div className='row'>
          {data}
          {this.state.subscriptionstatus === 'free' ? (
            <div className='col-md-6 col-lg-4'>
              <div className='border_box' onClick={this._getSubscribe}>
                <div className='border_box_title'>
                  <img
                    src={App_data.frontend_url + '/img/question_bank/question_icon-blu.svg'}
                    className='margin_bottom_20'
                    width='30'
                    alt=''
                  />
                  <p> {language.LC().SUBSCRIBE_FOR_4000_PRACTICE_QUESTIONS} </p>
                </div>
                <div className='padding_box'>
                  {renderHTMLContent(
                    this.state.SubsciptionMessage,
                    "div",
                    "view_question_height view_questionhtml modal-info-view-for-plan frm_question_height",
                    { contentEditable: 'false' }
                  )}
                </div>
                <div className='subscibe__btn text-center'>
                  <button
                    type='button'
                    className='btn btn-primary pointer_class'
                    onClick={this._getSubscribe}
                  >
                    {language.LC().SUBSCRIBE}
                  </button>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    );
  }
}

export default ViewFrmQues;



// WEBPACK FOOTER //
// ./src/views/FRM/FrmQueBank/ViewFrmQues/ViewFrmQues.js